import React, { useEffect, useState } from "react";
import classes from './TopicsMenu.module.css';
import TopicsMenuNode from "./TopicsMenuNode";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { onKeyDown } from "../../../../service";

const TopicsMenu = ({ topicsData, currentUrl, selectSubMenu, selectMenu, showAllAssessments, disableTopicTitle, lessonId }) => {

    const { direction, texts } = useSelector(state => state.translate);

    const navigate = useNavigate();

    const [subTopicCurrentID, setSubTopicCurrentID] = useState(showAllAssessments ? "all" : null)
    const [defaultTopicId, setDefaultTopicId] = useState(null)

    function setDefaultURL(value) {
        if (value.isLesson === true) {
            setDefaultTopicId(topicsData[0].id)
            navigate(`${currentUrl}/${value.id}`)
        }
        else {
            let findLesson = null
            if (value.children) {
                findLesson = topicsData[0].children.find(c => c.isLesson === true)
                setDefaultURL(findLesson)
            }
        }
    }

    function getLessonId(t) {
        if (t?.children?.length > 0)
            return getLessonId(t.children.find(x => x.visible))
        if (t?.isLesson)
            return t.id
        else
            return 0
    }

    useEffect(() => {
        if (topicsData && topicsData.length > 0 && currentUrl) {
            if (showAllAssessments) {
                navigate(`${currentUrl}/all`);
                setSubTopicCurrentID("all");
            }
            else {
                if (!selectSubMenu) {
                    let currentLessonId
                    if (lessonId && lessonId != "0")
                        currentLessonId = lessonId
                    else
                        currentLessonId = getLessonId(topicsData[0])
                    navigate(`${currentUrl}/${currentLessonId}`)
                    setSubTopicCurrentID(currentLessonId)
                }
                else {
                    if (topicsData?.[0]?.id) {
                        navigate(`${currentUrl}/${topicsData[0].id}`)
                        setSubTopicCurrentID(topicsData[0].id)
                    }
                }
            }
        }
    }, [currentUrl, topicsData])


    useEffect(() => {
        if (subTopicCurrentID)
            navigate(`${currentUrl}/${subTopicCurrentID}`);
    }, [subTopicCurrentID])

    const getTopicTitle = index => {
        switch (index) {
            case 0: return texts.subjects;
            case 1: return texts.contest;
            case 2: return texts.enrichment;
            default: return '';
        }
    }

    return (
        <div className={`${classes.AllTopics} ${classes[direction]}`}>
            {showAllAssessments && <div className={`${classes.Title} ${subTopicCurrentID === "all" ? classes.Active : ''}`} onClick={() => selectMenu && setSubTopicCurrentID("all")} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => selectMenu && setSubTopicCurrentID("all"))}>{texts.allAssessments}</div>}
            {topicsData && topicsData.map((t, index) => (
                <React.Fragment key={index}>
                    {t ? <>
                        {index !== 0 && <div className={classes.Line}></div>}
                        <div className={`${classes.Title} ${subTopicCurrentID === t.id ? classes.Active : ''} ${disableTopicTitle ? classes.DisableTitle : ''}`} onClick={() => selectMenu && setSubTopicCurrentID(t.id)}>{getTopicTitle(index)}</div>
                        <TopicsMenuNode disableEditLesson={true} disableDeleteLesson={true} topicsData={t.children} selectSubMenu={selectSubMenu} selectMenu={selectMenu} setSubTopicId={setSubTopicCurrentID} defaultTopicId={defaultTopicId}></TopicsMenuNode>
                    </> : ''}
                </React.Fragment>
            )
            )}
        </div >
    )

}
export default TopicsMenu